import React from 'react';
import { Button, Card, Grid, InputAdornment, Typography } from "@mui/material";
import SearchField from '../../../overrides/longSearchField';
import SearchIcon from "@mui/icons-material/Search";
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';

const FreezeHeader = ({ handleSearch, searchText, setOpen }) => {

    return (
        // <>
            <Card style={{ boxShadow: "0px 12px 23px rgba(62, 73, 84, 0.04)", borderRadius: "20px 20px 0px 0px" }}>
                <Grid container spacing={3} sx={{ padding: '30px' }} >
                    <Grid item lg={9.5} xl={9.5} xs={12} md={8.5} sm={8} sx={{ justifyContent: 'left' }}>
                        <SearchField
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    height: 50
                                }
                            }}
                            placeholder='Search'
                            onChange={handleSearch}
                            value={searchText}
                            fullWidth />
                    </Grid>
                    <Grid item lg={2.5} xl={2.5} xs={12} md={3.5} sm={4} sx={{ justifyContent: 'right' }}>
                        <Button variant='contained' size='medium' sx={{ height: 50 }} fullWidth endIcon={<DoubleArrowIcon />} onClick={() => setOpen(true)}
                        >
                            <Typography variant='t16_500'>Add Freeze Date</Typography>
                        </Button>
                    </Grid>
                </Grid>
            </Card>
        // </>
    )
}

export default FreezeHeader;